module.exports = __webpack_public_path__ + "img/login_logo.22d06dfb.png";